// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-container{--amplify-primary-color: #333333;--amplify-primary-tint: black}.fullscreen-container{height:100%;display:flex;flex-direction:column;overflow:hidden}.auth-modal{--container-height: inherit !important;--box-shadow: 0}", ""]);
// Exports
module.exports = exports;
